import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as navigation from 'Navigation';
import StorableRelevantItemsTabState from 'relevant-items/storables/StorableRelevantItemsTabState';
import StorableResultsTabState from 'results/linked-results/StorableResultsTabState';
import {fetchStorableViewAttributes} from 'samples/storables/graphql/fetchStorableViewAttributes';
import {asJQueryPromise} from 'util/Promises';

import * as GridDAO from '../GridDAO';
import StorableStore from '../StorableStore';
import BoxTabState from './BoxTabState';
import GridContentsTabState from './GridContentsTabState';
import GridFileState from './GridFileState';
import GridMetadataTabState from './GridMetadataTabState';

export default class BoxFileState extends GridFileState {
  static fileType: string;
  static override openFile: (fileId: string) => JQueryPromise<unknown>;

  override editURL(): string {
    return GridDAO.boxEditorURL(this.id);
  }

  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  override initialize(...args: Array<any>): void {
    super.initialize(...args);
    this.changeListener = this.changeListener.bind(this);
    this.registerListeners();

    const buffers = new navigation.BufferStates([new navigation.BufferState(), new navigation.BufferState()]);
    this.set({buffers});
    const boxTabState = new BoxTabState({gridId: this.id});
    buffers.at(0).add(boxTabState);
    boxTabState.set({active: true});

    const contentsTabState = new GridContentsTabState({gridId: this.id});
    const secondaryTabs = [contentsTabState, new GridMetadataTabState({gridId: this.id})];
    buffers.at(1).add(secondaryTabs);
    contentsTabState.set({active: true});

    if (this.hasResults()) {
      buffers.at(1).add(new StorableResultsTabState({storableId: this.id}));
    }

    if (BenchlingConfig.INVENTORY_STORABLE_RELEVANT_ITEMS) {
      buffers.at(1).add(new StorableRelevantItemsTabState({storableId: this.id}));
    }

    this.initIsWorkspaceSplitFromPreference();
  }
}

BoxFileState.fileType = ModelTypeConstants.BOX;

BoxFileState.openFile = (fileId: string) => {
  if (!BenchlingConfig.INVENTORY_STORABLE_RELEVANT_ITEMS) {
    return asJQueryPromise(Promise.resolve(new BoxFileState({id: fileId})));
  }

  const grid = StorableStore.getGrid(fileId);
  if (grid != null) {
    const fileState = new BoxFileState({id: fileId, name: grid.name, archiveRecord: grid.archiveRecord});
    fetchStorableViewAttributes(fileId).then((attrs) => fileState.set(attrs));
    return asJQueryPromise(Promise.resolve(fileState));
  }

  return asJQueryPromise(
    fetchStorableViewAttributes(fileId).then((attrs) => new BoxFileState({id: fileId, ...attrs}))
  );
};
